import { Icon, Row, Col, Tooltip, Button, Modal } from "antd";
import React, { Component } from "react";
import { withTranslation } from 'react-i18next';
import { SeparateNumberFormat } from "../services/utils";
import AudienceSummaryComponent from "./AudienceSummaryComponent";
import screenIcon from "../images/screen-icon-white.svg";
import { getTotalPice, getCPM, buildAudienceDisplays } from "../services/display";
import NumberFormat from "./NumberFormat";
import { debounce } from "lodash";
import CardAverageCPMHolder from "./Styles/cardAverageCPMStyle";

class CardAverageCPM extends Component {

  constructor(props) {
    super(props);
    // Build the payload when the debounce fires, not when it is scheduled: customContents is
    // redistributed after budget/cart changes, and stale promised_shows (0) would overwrite the audience
    this.debouncedGetAudience = debounce(() => this.getAudience(this.props), 1000);
  }

  state = {
    audienceModaVisible: false,
  };

  getAudience(props) {
    const { date_from, date_to, programmatic, dsp } = props;

    const bodyAudienceData = {
      "_method": "GET",
      "start_date": date_from,
      "end_date": date_to,
      "displays": this.parseDisplays(props),
      "type": programmatic,
      "external_dsp_id": dsp && programmatic == "programmatic" ? dsp.id : null,
    }
    this.props.getAudience(bodyAudienceData);
  }

  componentWillMount() {
    const { cart } = this.props;

    if (!cart || cart.length === 0) return this.props.cleanAudience();

    this.debouncedGetAudience();
  }

  componentWillUnmount() {
    this.debouncedGetAudience.cancel();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (Object.keys(nextProps.audience).length !== 0 && (!nextProps.cart || nextProps.cart.length === 0))
      return this.props.cleanAudience();

    if (this.audienceIsUpdated(nextProps) || nextProps.customContents !== this.props.customContents)
      this.debouncedGetAudience();
  }

  audienceIsUpdated = (nextProps) => {
    const { cart, date_from, date_to, amountBudget } = this.props;

    if (nextProps.amountBudget !== amountBudget)
      return true;

    if (nextProps.date_from !== date_from || nextProps.date_to !== date_to)
      return true;

    if ((nextProps.cart && cart) && (nextProps.cart.length !== cart.length))
      return true;
    return false;
  }

  parseDisplays = (props) => {
    const { cart, customContents, date_from, date_to, programmatic, editCampaignActive, currentCampaign } = props;
    if (programmatic !== 'programmatic')
      return cart.map(display => ({ id: display.id, promised_shows: null }));

    return buildAudienceDisplays(
      customContents,
      cart,
      date_from,
      date_to,
      editCampaignActive,
      currentCampaign
    );
  }

  handleAudienceModal = () => {
    this.setState(prevState => ({
      audienceModaVisible: !prevState.audienceModaVisible,
    }));
  }

  countScreensWithoutRepeating(listRelations){
    let list = []
    listRelations.forEach(display => {
      if(!list.includes(display.id)){
        list.push(display.id)
      }
    })
    return list.length
  }

  render() {
    const { t,
            cart,
            date_from,
            date_to,
            audience,
            view ,
            programmatic,
            user,
            currentCampaign,
            editCampaignActive,
            amountBudget,
            realAmount,
            currencyExchangeRate,
            dsp,
            customContents,
            loadingAudience,
            stepsCurrent} = this.props;

    // New campaigns get their spots distributed when leaving the Spots step: until then the
    // impacts (and CPM) would be computed with 0 promised_shows
    const hasPromisedShows = (customContents || []).some(content => content.promised_shows > 0);
    if (stepsCurrent === 0 && !editCampaignActive && !hasPromisedShows) return null;

    const { audienceModaVisible } = this.state;

    let amountBudgetProgrammatic = amountBudget
    if (view === 'cartAudienceVideoUpload'){
      amountBudgetProgrammatic = Math.round(realAmount * 100) / 100
    }

    // Cost per thousand impressions
    let campaingPrice = programmatic === "programmatic" ? amountBudgetProgrammatic : getTotalPice(cart, date_from, date_to)
    let CPM =  getCPM(campaingPrice, audience.total_impacts)

    return (
      (audience.displays_with_audience ?
        <CardAverageCPMHolder stepsCurrent={stepsCurrent}>
          <div className={(audience.displays_with_audience.length > 0 && audience.total_audience !== 0) ? (view ? view : "cartAudience") : "cartAudienceHidden"} >
            <div className="cardGeneral">
              <Row justify="center">
                <Col>
                  <div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <div className='infoDate'>{t('CPM Average')}</div>
                      <Tooltip
                        placement="right"
                        title={t('(CPM) cost per thousand impression')}>
                        <Icon className="cardAudienceIconInfoInfo" type="info-circle" theme="outlined" style={{fontSize: '12px', marginBottom: '1px'}} />
                      </Tooltip>
                    </div>
                    <div className='brandClientNameContainer'>
                      { cart[0] &&
                          <p className='brandClientName'>
                            <NumberFormat
                              value={CPM}
                              currency={ cart[0].price_currency || ''}
                              prefix="US$ "
                            />
                          </p>
                      }
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <Icon className="cardAudienceIconInfo" type="team" theme="outlined" style={{fontSize: '14px', marginBottom: '2px'}} />
                      <div className='infoDate'>{t("Audience impressions")}</div>
                    </div>
                    <div className='brandClientNameContainer'>
                      <p className='brandClientName'>
                        {loadingAudience ? <Icon type="loading" /> : SeparateNumberFormat(audience.total_impacts)}
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
            <Row>
              <div className="line-divider ant-divider ant-divider-horizontal"></div>
              <Col className={"col-card"} style={{ fontSize: "large", margin: "5px 11px 5px 11px" }}>
                <Row type="flex" justify="space-around">
                  <Tooltip
                    placement="left"
                    title={`${t('Screens measuring audience')}.`}>
                    {this.countScreensWithoutRepeating(audience.displays_with_audience)} <Icon type="audit" theme="outlined" />
                  </Tooltip>
                  <Tooltip
                    placement="left"
                    title={`${t('Total screens added in the campaign')}.`}>
                    {cart.length}
                    <img src={screenIcon} className="iconAudience" style={{height: "18px", width: "18px"}} />
                  </Tooltip>
                  <Tooltip
                    placement="left"
                    title={`${t('See audience details')}`}
                  >
                    <Button
                      className="seeDetailsBtn"
                      onClick={this.handleAudienceModal}
                    >
                      {t('See detail')}
                    </Button>
                  </Tooltip>
                </Row>
              </Col>
            </Row>
          </div>
          <Modal
            title={t("Audience summary")}
            visible={audienceModaVisible}
            onCancel={this.handleAudienceModal}
            footer={[
              <Button key="back" onClick={this.handleAudienceModal}>
                OK
              </Button>,
            ]}
            width={1000}
            style={{ top: "10px" }}
          >
            <AudienceSummaryComponent
              t={t}
              start_date={date_from}
              end_date={date_to}
              displays={cart}
              displaysId={cart.map(display => display.id)}
              resetAudience={audienceModaVisible}
              user={user}
              campaign={ editCampaignActive ? currentCampaign : null}
              proposalAudience={this.props.proposalAudience}
              getProposalAudience={this.props.getProposalAudience}
            />
          </Modal>
        </CardAverageCPMHolder>
        : null
      )
    );
  }
}

export default withTranslation()(CardAverageCPM);